import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification/Notification";
import Loading from "../../components/Loading/Loading";
import { changepasswordByAdmin } from "../../store/action";
import history from "../../utils/HistoryUtils";

import {
  Paper,
  makeStyles,
  Button,
  Box,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  footerBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
  },
}));

const ChangePassword = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);

  const { changesuccess, changeerrors } = useSelector(
    (state) => state.authReducer
  );

  const dId = btoa(match.params.id);

  const [data, setData] = useState({
    password: "",
    confirm_password: "",
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const { formState: { errors }, reset } = useForm();

  const handleSubmit = (e) => {
    e.preventDefault();
    data.decode_id = dId;
    dispatch(changepasswordByAdmin(data));
    setStaffNotify(true);
  };

  const backPage = () => {
    history.goBack();
  };

  useEffect(() => {
    if (changesuccess?.message || changeerrors?.message) {
      setTimeout(() => setStaffNotify(false), 4000);
    }
  }, [changesuccess, changeerrors]);

  return (
    <>
      {loading && <Loading open={loading} />}

      {staffNotify && changesuccess?.message && (
        <Notification data={changesuccess?.message} status="success" />
      )}

      {staffNotify && changeerrors?.message && (
        <Notification data={changeerrors?.message} status="error" />
      )}

      <Paper className={classes.root}>
        <Box mb={3}>
          <Typography variant="h5">Change Password</Typography>
        </Box>

        <form onSubmit={handleSubmit} autoComplete="off">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                type="password"
                name="password"
                label="New Password"
                value={data.password}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                className={classes.formControl}
                helperText={changeerrors?.message || ""}
                error={!!changeerrors?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type="password"
                name="confirm_password"
                label="Confirm Password"
                value={data.confirm_password}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                className={classes.formControl}
                helperText={changeerrors?.message || ""}
                error={!!changeerrors?.message}
              />
            </Grid>
          </Grid>

          <Box className={classes.footerBtn}>
            <Button variant="outlined" onClick={backPage}>Cancel</Button>
            <Button type="submit" variant="contained">Submit</Button>
          </Box>
        </form>
      </Paper>
    </>
  );
};

export default ChangePassword;
